import React, { Component, Fragment } from "react";
import { Row, Col, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import _ from "lodash";
import ThisTable from "../../Common/ThisTable";
import CommonModal from "../../Common/CommonModal";
import CustomForm from "../../../libraries/form";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { ButtonCirclePlus } from "../../Common/Buttons";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { ReservationSchema } from "./ReservationSchema";
import { getReservationTableColumns } from "./reservationTableColumns";
import { getMaterialsTableColumns } from "./reservationMaterialsColumns";
import { languageService } from "../../../Language/language.service";
import { ToastService } from "../../../utils/toastify";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "../../../reduxCURD/actions";
import { getAppMockupsTypes } from "../../../reduxRelated/actions/diagnosticsActions";
import { versionInfo } from "../../MainPage/VersionInfo";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import { commonPageStyle } from "../../Common/Summary/styles/CommonPageStyle";
import { commonFilterStyles } from "../../Common/Filters/styles/CommonFilterStyle";
import { themeService } from "../../../theme/service/activeTheme.service";
import { commonSummaryStyle } from "../../Common/Summary/styles/CommonSummaryStyle";
import "../IMSManagement.css";

const emptyItem = () => ({ sku: "", quantityRequested: 1 });

class Reservation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      reservationFields: { workOrderId: "", warehouseCode: "" },
      reservationSchema: ReservationSchema,
      items: [emptyItem()],
      selectedMRId: "",
      pageSize: 10,
      page: 0,
      dropdownOpen: false,
      modalMode: "Add", // "Add", "View", "Issue", "Return"
      editItem: null,
      activeReservation: null,
    };

    // Binding Handlers
    this.toggle = this.toggle.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.addItemRow = this.addItemRow.bind(this);
    this.removeItemRow = this.removeItemRow.bind(this);
    this.updateItemField = this.updateItemField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onMRChange = this.onMRChange.bind(this);
    this.handlePageSave = this.handlePageSave.bind(this);
    this.handleActionClick = this.handleActionClick.bind(this);
    this.confirmRelease = this.confirmRelease.bind(this);
    this.confirmIssue = this.confirmIssue.bind(this);
    this.confirmReturn = this.confirmReturn.bind(this);
    this.setReleaseModalOpener = this.setReleaseModalOpener.bind(this);
  }
  componentDidMount() {
    this.fetchInitialData();
  }

  componentDidUpdate(prevProps) {
    const { actionType, Reservation } = this.props;

    if (prevProps.actionType !== actionType) {
      if (actionType === "RESERVATION_CREATE_SUCCESS") {
        this.handleActionSuccess();
      }
      if (actionType === "RESERVATION_CREATE_FAILURE") {
        ToastService.Error(languageService("Failed to process action."), "");
      }
    }

    // Refresh dynamic schema on lookup updates
    if (this.state.showModal && prevProps.applicationlookupss !== this.props.applicationlookupss) {
      this.compileReservationSchema();
    }
  }
  fetchInitialData() {
    this.props.getReservations("");
    this.props.getMaintenances("");
    this.props.getApplicationlookupss("wims-wareHouse");
    this.props.getAppMockupsTypes("materialTypes");
  }

  handleActionSuccess() {
    const { activeReservation } = this.state;
    this.props.getReservations("");

    let msg = "Action successful.";
    if (!activeReservation) msg = "Reservation created successfully.";

    if (this.props.Reservation && this.props.Reservation.errorMessage) {
      ToastService.Error(languageService(this.props.Reservation.errorMessage), "");
    } else {
      ToastService.Success(languageService(msg));
      this.closeModal();
    }

    this.setState({ activeReservation: null });
  }
  getWarehouses() {
    const raw = this.props.applicationlookupss || [];
    return (Array.isArray(raw) ? raw : raw.data || []).filter((item) => item.listName === "wims-wareHouse");
  }

  getMaintenanceRecords() {
    const raw = this.props.maintenances || [];
    return (Array.isArray(raw) ? raw : raw.data || []).filter((m) => m.status === "In Progress" || m.status === "New");
  }

  getMaterials() {
    return (this.props.materialTypes || []).filter((m) => m.opt1 && m.opt1.WIMS === true && m.opt1.status === "active");
  }

  compileReservationSchema() {
    const { modalMode, editItem } = this.state;
    const isView = modalMode === "View";
    const isTransaction = modalMode === "Issue" || modalMode === "Return";

    let maintenanceRecords = this.getMaintenanceRecords();
    let warehouses = this.getWarehouses();
    const defaultWH = warehouses.find((w) => w.opt1 && w.opt1.isDefault === true);

    const mrOptions = [
      { val: "", text: languageService("Select") },
      ...maintenanceRecords.map((m) => ({ val: m._id, text: m.mrNumber || m._id })),
    ];
    const whOptions = warehouses.map((w) => ({
      val: w.code,
      text: `${w.code}${w.opt1 && w.opt1.isDefault ? " (Default)" : ""}`,
    }));

    let schema = _.cloneDeep(ReservationSchema);
    const titles = {
      Add: languageService("Create Reservation"),
      View: languageService("View Reservation"),
      Return: languageService("Return Materials"),
      Issue: languageService("Issue Materials"),
    };
    schema.stateTitle.Add = titles[modalMode] || titles.Add;
    schema.sections.forEach((section) => {
      if (section.id === "ReservationInfo") {
        section.fields.forEach((field) => {
          if (isView || isTransaction) field.disabled = true;
          if (field.id === "status") field.hide = !(isView || isTransaction);
        });
      }

      if (section.id === "footerArea") {
        if (isView) {
          section.fields = section.fields.filter((f) => f.id === "closeDialog");
        }
        section.fields.forEach((f) => {
          if (f.id === "closeDialog") f.labelValue = languageService("Close");
          if (f.id === "submitData" && isTransaction) f.labelValue = languageService(modalMode);
        });
      }
    });

    const populatedSchema = updateShortSchema(schema, {
      workOrderId: { selectOptions: mrOptions },
      warehouseCode: { selectOptions: whOptions },
    });

    this.setState({
      reservationSchema: populatedSchema,
      reservationFields: {
        workOrderId: editItem ? editItem.workOrderId : "",
        warehouseCode: editItem ? editItem.warehouseCode : defaultWH ? defaultWH.code : "",
        status: editItem ? languageService(editItem.status || "active") : "",
      },
    });
  }

  openModal(mode = "Add", item = null) {
    this.setState({ modalMode: mode, editItem: item }, () => {
      this.compileReservationSchema();
      let reservationItems = [emptyItem()];

      if (item && item.materials) {
        reservationItems = item.materials.map((m) => ({
          ...m,
          quantityToReturn: (m.quantityIssued || 0) - (m.quantityReturned || 0),
          quantityToIssue: (m.quantityReserved || 0) - (m.quantityIssued || 0),
        }));
      }

      this.setState({
        showModal: true,
        items: reservationItems,
        selectedMRId: item ? item.workOrderId : "",
      });
    });
  }

  closeModal() {
    this.setState({ showModal: false, modalMode: "Add", editItem: null });
  }

  toggle() {
    this.setState((prev) => ({ dropdownOpen: !prev.dropdownOpen }));
  }

  handlePageSave(page, pageSize) {
    this.setState({ page, pageSize });
  }

  handleActionClick(action, item) {
    const actionMap = {
      View: () => this.openModal("View", item),
      Issue: () => this.openModal("Issue", item),
      Return: () => this.openModal("Return", item),
      Release: () => {
        this.setState({ activeReservation: item });
        this.releaseModalOpener(true);
      },
    };
    if (actionMap[action]) {
      actionMap[action]();
    }
  }

  onMRChange(workOrderId) {
    this.setState({ selectedMRId: workOrderId });
    return [];
  }

  addItemRow() {
    this.setState((prev) => ({ items: [...prev.items, emptyItem()] }));
  }

  removeItemRow(index) {
    this.setState((prev) => ({ items: prev.items.filter((_, i) => i !== index) }));
  }

  updateItemField(index, field, value) {
    this.setState((prev) => {
      const items = [...prev.items];
      items[index] = { ...items[index], [field]: value };
      return { items };
    });
  }

  setReleaseModalOpener(opener) {
    this.releaseModalOpener = opener;
  }

  confirmRelease() {
    const { activeReservation } = this.state;
    if (!activeReservation) return;

    this.props.createReservation({
      type: "RELEASE",
      data: {
        reservationId: activeReservation.reservationId || activeReservation._id,
        workOrderId: activeReservation.workOrderId,
        releasedBy: versionInfo.getApplicationType(),
      },
    });
  }

  confirmIssue() {
    const { activeReservation } = this.state;
    if (!activeReservation) return;

    const itemsToIssue = (activeReservation.materials || [])
      .filter((it) => (it.quantityReserved || 0) > (it.quantityIssued || 0))
      .map((it) => ({
        sku: it.sku,
        quantityIssued: (it.quantityReserved || 0) - (it.quantityIssued || 0),
      }));

    if (itemsToIssue.length === 0) return;

    this.props.createReservation({
      type: "ISSUE",
      data: {
        reservationId: activeReservation.reservationNumber,
        workOrderId: activeReservation.workOrderId,
        warehouseCode: activeReservation.warehouseCode,
        issuedBy: versionInfo.getApplicationType(),
        items: itemsToIssue,
      },
    });
  }

  confirmReturn() {
    const { activeReservation } = this.state;
    if (!activeReservation) return;

    const itemsToReturn = (activeReservation.materials || [])
      .filter((it) => (it.quantityIssued || 0) > (it.quantityReturned || 0))
      .map((it) => ({
        sku: it.sku,
        quantityReturned: (it.quantityIssued || 0) - (it.quantityReturned || 0),
      }));

    if (itemsToReturn.length === 0) return;

    this.props.createReservation({
      type: "RETURN",
      data: {
        reservationId: activeReservation.reservationId,
        workOrderId: activeReservation.workOrderId,
        warehouseCode: activeReservation.warehouseCode,
        returnedBy: versionInfo.getApplicationType(),
        items: itemsToReturn,
      },
    });
  }

  onSubmit({ fields }) {
    const { items, modalMode, editItem } = this.state;
    const { workOrderId, warehouseCode } = fields;

    if (modalMode === "Return") {
      const returnItems = items
        .filter((it) => (it.quantityToReturn || 0) > 0)
        .map((it) => ({ sku: it.sku, quantityReturned: Number(it.quantityToReturn) }));

      if (returnItems.length === 0) return ToastService.Error(languageService("Please specify quantities to return."), "");

      this.props.createReservation({
        type: "RETURN",
        data: {
          reservationId: editItem.reservationId,
          workOrderId: editItem.workOrderId,
          warehouseCode: editItem.warehouseCode,
          returnedBy: versionInfo.getApplicationType(),
          items: returnItems,
        },
      });
      return;
    }
    if (modalMode === "Issue") {
      const issueItems = items
        .filter((it) => (it.quantityToIssue || 0) > 0)
        .map((it) => ({ sku: it.sku, quantityIssued: Number(it.quantityToIssue) }));

      if (issueItems.length === 0) return ToastService.Error(languageService("Please specify quantities to issue."), "");

      this.props.createReservation({
        type: "ISSUE",
        data: {
          reservationId: editItem.reservationNumber,
          workOrderId: editItem.workOrderId,
          warehouseCode: editItem.warehouseCode,
          issuedBy: versionInfo.getApplicationType(),
          items: issueItems,
        },
      });
      return;
    }

    for (const item of items) {
      if (!item.sku) return ToastService.Error(languageService("Each item must have a SKU selected."), "");
      if (!item.quantityRequested || item.quantityRequested <= 0)
        return ToastService.Error(languageService("Each item quantity must be greater than 0."), "");
    }

    const maint = this.getMaintenanceRecords().find((m) => m._id === workOrderId);
    const mrNumber = maint ? maint.mrNumber || maint._id : "";

    this.props.createReservation({
      type: "CREATE",
      data: {
        workOrderId: mrNumber,
        mrNumber,
        workOrderDescription: maint ? maint.maintenanceType : "",
        requestedBy: versionInfo.getApplicationType(),
        warehouseCode,
        items: items.map((it) => ({ sku: it.sku, quantityRequested: Number(it.quantityRequested) })),
      },
    });
  }

  renderTableActionHeader() {
    return (
      <Row>
        <Col md="9">
          <div style={{ ...themeService(commonPageStyle.commonSummaryHeadingContainer), display: "inline-block" }}>
            <h4 style={themeService(commonPageStyle.commonSummaryHeadingStyle)}>{languageService("Reservations")}</h4>
          </div>
        </Col>
        <Col md="3" style={{ textAlign: "right", paddingRight: "30px", paddingTop: "10px" }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <MyButton onClick={() => this.props.getReservations("")}>{languageService("Refresh")}</MyButton>
            <MyButton onClick={() => this.openModal("Add")}>{languageService("Create")}</MyButton>
          </div>
        </Col>
        <hr style={{ borderBottom: "1px solid rgb(209, 209, 209)", width: "96.5%" }} />
      </Row>
    );
  }

  renderCustomSections() {
    const { items, modalMode } = this.state;
    const isView = modalMode === "View";
    const materials = this.getMaterials();

    const columns = getMaterialsTableColumns({
      modalMode,
      materials,
      updateItemField: this.updateItemField,
      removeItemRow: this.removeItemRow,
    });

    return [
      {
        position: "body",
        sectionPosition: "start",
        sectionId: "ReservationItems",
        customComp: [
          <div style={{ padding: "0 15px", width: "100%" }} key="items">
            <div className="reservation-items-header">
              <span className="reservation-items-title">
                {languageService("Items")} {!isView && <span style={{ color: "red" }}>*</span>}
              </span>
              {!isView && modalMode === "Add" && (
                <TooltipContainer tooltipText={languageService("Add Material")}>
                  <ButtonCirclePlus handleClick={this.addItemRow} {...themeService(commonSummaryStyle.addButtonStyle(this.props))} />
                </TooltipContainer>
              )}
            </div>

            <ThisTable
              tableColumns={columns}
              tableData={items}
              pageSize={items.length > 0 ? items.length : 1}
              minRows={1}
              pagination={false}
              forDashboard={false}
              height={"auto"}
            />

            {items.length === 0 && (
              <div className="reservation-empty-state">{languageService("No items added. Click + to add a material.")}</div>
            )}
          </div>,
        ],
      },
    ];
  }

  render() {
    const { showModal, reservationFields, reservationSchema, pageSize, page, dropdownOpen, activeReservation } = this.state;
    const reservationList = Array.isArray(this.props.Reservations)
      ? this.props.Reservations
      : (this.props.Reservations && this.props.Reservations.data) || [];

    const columns = getReservationTableColumns(this);

    const pageOptions = [5, 10, 15, 20, 25, 30, 40, 50].map((option) => (
      <DropdownItem onClick={() => this.handlePageSave(0, option)} key={option} style={themeService(commonFilterStyles.pageSizeStyle)}>
        {option}
      </DropdownItem>
    ));

    return (
      <Fragment>
        <div className="ims-sub-content">
          <Col className="mainContent" md="12">
            {this.renderTableActionHeader()}

            <Row>
              <Col md={1}>
                <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }}>
                  <Dropdown isOpen={dropdownOpen} toggle={this.toggle} size="sm">
                    <DropdownToggle style={themeService(commonFilterStyles.pageSizeTogglerStyle)} caret>
                      {pageSize}
                    </DropdownToggle>
                    <DropdownMenu style={{ minWidth: "auto", fontSize: "12px", padding: "0px" }}>{pageOptions}</DropdownMenu>
                  </Dropdown>
                </div>
              </Col>
              <Col md="12">
                <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }}>
                  <ThisTable
                    tableColumns={columns}
                    tableData={reservationList}
                    pageSize={pageSize}
                    minRows={1}
                    pagination={true}
                    forDashboard={false}
                    handlePageChange={(p) => this.handlePageSave(p, pageSize)}
                    page={page}
                    height={"auto"}
                    onClickSelect
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </div>

        {showModal && (
          <CustomForm
            mode="dialog"
            fieldsData={reservationFields}
            currState="Add"
            formSchema={reservationSchema}
            closeDialog={this.closeModal}
            parentRef={{
              onSubmit: this.onSubmit,
              closeModal: this.closeModal,
              onMRChange: this.onMRChange,
            }}
            formCustomSectionComps={this.renderCustomSections()}
          />
        )}

        <CommonModal
          headerText={languageService("Confirm Release")}
          footerSubmitText={languageService("Confirm")}
          setModalOpener={this.setReleaseModalOpener}
          handleSubmitClick={this.confirmRelease}
        >
          <div style={{ padding: "10px" }}>
            {languageService("Are you sure you want to release this reservation?")}
            {activeReservation && (
              <div style={{ marginTop: "10px", fontWeight: "bold" }}>
                {languageService("MR#")}: {activeReservation.mrNumber} <br />
                {languageService("Reservation No.")}: {activeReservation.reservationNumber}
              </div>
            )}
          </div>
        </CommonModal>
      </Fragment>
    );
  }
}

const actionOptions = {
  create: true,
  update: true,
  read: true,
  delete: true,
  others: {
    getAppMockupsTypes,
    getApplicationlookupss: curdActions.getApplicationlookupss,
    getMaintenances: (...args) => curdActions.getMaintenances(...args),
  },
};

const variables = {
  ReservationReducer: { Reservations: [] },
  maintenanceReducer: { maintenance: "", maintenances: [] },
  diagnosticsReducer: { materialTypes: [] },
  applicationlookupsReducer: { applicationlookupss: [] },
};

export default CRUDFunction(
  Reservation,
  "Reservation",
  actionOptions,
  variables,
  ["diagnosticsReducer", "applicationlookupsReducer", "maintenanceReducer", "ReservationReducer"],
  "wims/materialReservation",
);



// WEBPACK FOOTER //
// ./src/components/IMS/Reservation/Reservation.jsx